import axios from "axios";

export const fetchApprovals = async () => {
  const response = await axios.get("/Approvals/list");
  return response;
};
